import { useCallback, useEffect, useState } from "react";
import Layout from "../../../Components/Layout";
import AttendeeStepper from "../../../Components/OrderMgt/Attendee/AttendeeStepper";
import CancleRequests from "../../../Components/OrderMgt/CancelRequests/CancleRequests";
import useHttpHook from "../../../Hooks/HttpHook";
import {
  GetAllAttendees,
  GetAllCancelRequests,
  OrganizerEventApi,
} from "../../../utils/ApiConstant";
import { OrderLanguage } from "../../../utils/Languages";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createObjectForPaginatedResult } from "../../../utils/Helper";
import { showErrorToast } from "../../../utils/notify";

const CancleRequestsPage = () => {
  const [loading, sendRequest, error] = useHttpHook();
  const [events, setEvents] = useState("");
  const [cancleRequests, setCancleRequests] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [attendeeList, setAttendeeList] = useState(null);
  const query = new URLSearchParams(window.location.search);
  const event = query.get("event");
  const navigate = useNavigate();

  useEffect(() => {
    getList();
    if (event !== null) {
      setSelectedEvent(event);
    }
  }, []);

  useEffect(() => {
    getEventsOfOrganizer();
    if (event === null || (event !== null && selectedEvent === event)) {
      getCancleTicketRequests();
    }
  }, [selectedEvent]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const getEventsOfOrganizer = useCallback(async () => {
    try {
      const response = await sendRequest(OrganizerEventApi, {
        method: "get",
      });
      setEvents(response.data);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getCancleTicketRequests = async (page = 1) => {
    try {
      let response = await sendRequest(
        `${GetAllCancelRequests}?page=${page}` +
          (selectedEvent ? `&event=${selectedEvent}` : ""),
        {
          method: "get",
        }
      );
      if (page === 1) {
        setCancleRequests(response);
      } else {
        setCancleRequests((prevState) =>
          createObjectForPaginatedResult(response, prevState, "paginate")
        );
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getList = async (page = 1) => {
    try {
      let response = await sendRequest(`${GetAllAttendees}?page=${page}`, {
        method: "get",
      });
      if (page === 1) {
        setAttendeeList(response);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelect = (event) => {
    if (event !== null && event !== "") {
      navigate("/organizer/cancelTicket/requests?event=" + event);
    } else {
      navigate("/organizer/cancelTicket/requests");
    }
    setSelectedEvent(event);
  };

  const FilterComponent = () => (
    <div className="event-attendees-filter-field">
      <label className="visually-hidden" htmlFor="eventAttendeesCancelEventFilter">
        Event name
      </label>
      <select
        id="eventAttendeesCancelEventFilter"
        className="event-attendees-event-select"
        value={selectedEvent || ""}
        onChange={(e) => handleSelect(e.target.value)}
      >
        <option value="">Select Event Name</option>
        {events?.itemsList?.map((eventItem) => (
          <option key={eventItem._id} value={eventItem._id}>
            {eventItem.title}
          </option>
        ))}
      </select>
    </div>
  );

  return (
    <Layout
      Heading={OrderLanguage.CancelRequests.heading}
      TitleMark={true}
      TitleMarkClassName="event-attendees-title-mark"
      TitleClassName="event-attendees-title"
      HeadClassName="event-page-head event-create-head event-create-head--split event-attendees-head"
      CreateHead
      ExtraclassName="event-attendees-panel event-attendees-cancel-panel"
      activeMenuId="attendees"
      extraElement={<FilterComponent />}
    >
      <div className="event-attendees-body">
        <AttendeeStepper
          cancleRequests={cancleRequests?.data?.paginator?.itemCount}
          attendees={attendeeList?.data?.paginator?.itemCount}
        />

        <CancleRequests
          list={cancleRequests}
          isLoading={loading}
          isError={error}
          getCancleTicketRequests={getCancleTicketRequests}
        />
      </div>
    </Layout>
  );
};

export default CancleRequestsPage;
